import { render, staticRenderFns } from "./noData.vue?vue&type=template&id=cdbc46f8&scoped=true"
import script from "./noData.vue?vue&type=script&lang=js"
export * from "./noData.vue?vue&type=script&lang=js"
import style0 from "./noData.vue?vue&type=style&index=0&id=cdbc46f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbc46f8",
  null
  
)

export default component.exports